import { APP_STORE_URL, GOOGLE_PLAY_URL } from "../data/appLaunch";

const APP_STORE_BADGE = "/badges/app-store-badge.svg";
const GOOGLE_PLAY_BADGE = "/badges/google-play-badge.svg";

const heightClasses = {
    nav: "h-9",
    default: "h-11 sm:h-12",
    large: "h-12 sm:h-14",
};

export default function StoreBadges({
    className = "",
    size = "default",
    align = "center",
    onClick,
}) {
    const heightClass = heightClasses[size] || heightClasses.default;
    const alignmentClass =
        align === "start" ? "justify-center lg:justify-start" : "justify-center";
    const linkClass =
        "inline-flex shrink-0 rounded-lg transition-opacity hover:opacity-85 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2";

    return (
        <div className={`flex flex-wrap items-center gap-3 ${alignmentClass} ${className}`}>
            <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onClick}
                data-testid="app-store-badge-link"
                aria-label="Download on the App Store"
                className={linkClass}
            >
                <img
                    src={APP_STORE_BADGE}
                    alt="Download on the App Store"
                    className={`${heightClass} w-auto`}
                />
            </a>
            <a
                href={GOOGLE_PLAY_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onClick}
                data-testid="google-play-badge-link"
                aria-label="Get it on Google Play"
                className={linkClass}
            >
                <img
                    src={GOOGLE_PLAY_BADGE}
                    alt="Get it on Google Play"
                    className={`${heightClass} w-auto`}
                />
            </a>
        </div>
    );
}
